import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  pcrFormAccidentTrauma: null,
  pcrFormAccidentTraumaHospital: null,
  pcrFormOtherTrauma: null,
  pcrFormOtherTraumaHospital: null,
  pcrFormDisease: null,
  pcrFormDiseaseHospital: null,
  pcrFormHeart: null,
  pcrFormHeartHospital: null,
  pcrFormBrainStroke: null,
  pcrFormBrainStrokeHospital: null,
  pcrFormWithoutPatient: null,
  pcrFormWithoutPatientHospital: null,
  //qc
  qCSurvey: [],
  qCOnlineUsers: [],
  qCUsersLoginLogout: [],
  qCCalls: [],
  qCMissionTimes: [],
  qCMissionFenceTimes: [],
  qCTechnicianPerformancePagination: [],
  qCUsersForQC: [],
  //amar
  missionPhoneWithResultByZone: [],
  patientCountByDiagnosis: [],
  inboundCalls: [],
  dailyByZone: [],
  dailyByGeographicalType: [],
  dailyByGeographicalTypeWithCode: [],
  amarCodeActivity: [],
  amarRefuel: [],
  amarHeatMap: [],
  amarBaseTypeData: [],
  customReportInfo: [],
  errorStatus: null,
  averageTimesReport: null,
  stationAverageTimesReport: [],
  totalPages: 0,
  totalRecords: 0,
};
const getters = {
  getApiLoad_83: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_PcrFormAccidentTrauma(state, reports) {
    state.pcrFormAccidentTrauma = reports;
  },
  SET_PcrFormAccidentTraumaHospital(state, reports) {
    state.pcrFormAccidentTraumaHospital = reports;
  },
  SET_PcrFormOtherTrauma(state, reports) {
    state.pcrFormOtherTrauma = reports;
  },
  SET_PcrFormOtherTraumaHospital(state, reports) {
    state.pcrFormOtherTraumaHospital = reports;
  },
  SET_PcrFormDisease(state, reports) {
    state.pcrFormDisease = reports;
  },
  SET_PcrFormDiseaseHospital(state, reports) {
    state.pcrFormDiseaseHospital = reports;
  },
  SET_PcrFormHeart(state, reports) {
    state.pcrFormHeart = reports;
  },
  SET_PcrFormHeartHospital(state, reports) {
    state.pcrFormHeartHospital = reports;
  },
  SET_PcrFormBrainStroke(state, reports) {
    state.pcrFormBrainStroke = reports;
  },
  SET_PcrFormBrainStrokeHospital(state, reports) {
    state.pcrFormBrainStrokeHospital = reports;
  },
  SET_PcrFormWithoutPatient(state, reports) {
    state.pcrFormWithoutPatient = reports;
  },
  SET_PcrFormWithoutPatientHospital(state, reports) {
    state.pcrFormWithoutPatientHospital = reports;
  },
  //qc
  SET_QCSurveyReport(state, reports) {
    state.qCSurvey = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  SET_QCOnlineUsersReport(state, reports) {
    state.qCOnlineUsers = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  SET_QCUsersLoginLogoutReport(state, reports) {
    state.qCUsersLoginLogout = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  SET_QCCallsReport(state, reports) {
    state.qCCalls = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  SET_QCMissionTimesReport(state, reports) {
    state.qCMissionTimes = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  SET_QCMissionFenceTimesReport(state, reports) {
    state.qCMissionFenceTimes = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  SET_QCTechnicianPerformancePaginationReport(state, reports) {
    state.qCTechnicianPerformancePagination = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  SET_QCUsersForQCReport(state, reports) {
    state.qCUsersForQC = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  //amar
  SET_MissionPhoneWithResultByZone(state, reports) {
    state.missionPhoneWithResultByZone = reports;
  },
  SET_PatientCountByDiagnosis(state, reports) {
    state.patientCountByDiagnosis = reports;
  },
  SET_InboundCalls(state, reports) {
    state.inboundCalls = reports;
  },
  SET_DailyByZone(state, reports) {
    state.dailyByZone = reports;
  },
  SET_DailyByGeographicalType(state, reports) {
    state.dailyByGeographicalType = reports;
  },
  SET_DailyByGeographicalTypeWithCode(state, reports) {
    state.dailyByGeographicalTypeWithCode = reports;
  },
  SET_AmarCodeActivityReport(state, reports) {
    state.amarCodeActivity = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  SET_AmarRefuelReport(state, reports) {
    state.amarRefuel = reports.items;
    state.totalPages = reports.totalPages;
    state.totalRecords = reports?.totalRecords ?? 0;
  },
  SET_AmarHeatMapReport(state, reports) {
    state.amarHeatMap = reports;
  },
  SET_AmarBaseTypeDataReport(state, reports) {
    state.amarBaseTypeData = reports;
  },
  SET_CustomReportInfo(state, customReport) {
    state.customReportInfo = customReport;
  },
  SET_AverageTimesReport(state, averageTimesReport) {
    state.averageTimesReport = averageTimesReport;
  },
  SET_AverageStationTimesReport(state, stationAverageTimesReport) {
    state.stationAverageTimesReport = stationAverageTimesReport;
  },
};
const actions = {
  errorReport({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getPcrFormAccidentTrauma({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        '/Reports/PcrFormAccidentTrauma?missionPhoneId=' +
        missionPhoneId +
        '&patientId=' +
        patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormAccidentTrauma', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormAccidentTraumaHospital({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        '/Reports/HospitalPcrFormAccidentTrauma?missionPhoneId=' +
        missionPhoneId +
        '&patientId=' +
        patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormAccidentTraumaHospital', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormOtherTrauma({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        '/Reports/PcrFormOtherTrauma?missionPhoneId=' + missionPhoneId + '&patientId=' + patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormOtherTrauma', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormOtherTraumaHospital({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        '/Reports/HospitalPcrFormOtherTrauma?missionPhoneId=' +
        missionPhoneId +
        '&patientId=' +
        patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormOtherTraumaHospital', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormDisease({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get('/Reports/PcrFormDisease?missionPhoneId=' + missionPhoneId + '&patientId=' + patientId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PcrFormDisease', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormDiseaseHospital({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        '/Reports/HospitalPcrFormDisease?missionPhoneId=' +
        missionPhoneId +
        '&patientId=' +
        patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormDiseaseHospital', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getAverageTimesReportDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Reports/TimeAverage', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params,
      })
      .then((response) => {
        commit('SET_AverageTimesReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getStationAverageTimesReportDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Reports/StationTimeAverage', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params,
      })
      .then((response) => {
        commit('SET_AverageStationTimesReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormHeart({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get('/Reports/PcrFormHeart?missionPhoneId=' + missionPhoneId + '&patientId=' + patientId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PcrFormHeart', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormHeartHospital({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get('/Reports/PcrFormHeart?missionPhoneId=' + missionPhoneId + '&patientId=' + patientId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PcrFormHeart', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormBrainStroke({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        '/Reports/PcrFormBrainStroke?missionPhoneId=' + missionPhoneId + '&patientId=' + patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormBrainStroke', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormBrainStrokeHospital({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        '/Reports/HospitalPcrFormBrainStroke?missionPhoneId=' +
        missionPhoneId +
        '&patientId=' +
        patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormBrainStrokeHospital', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormWithoutPatient({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .get('/Reports/PcrFormWithoutPatient?missionPhoneId=' + missionPhoneId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PcrFormWithoutPatient', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPcrFormWithoutPatientHospital({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .get('/Reports/HospitalPcrFormWithoutPatient?missionPhoneId=' + missionPhoneId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PcrFormWithoutPatientHospital', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  //qc
  getQCSurveyReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, missionId, surveyCategoryId, pageNumber, pageSize },
  ) {
    let url = '/Reports/Surveys?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (missionId) {
      url += '&MissionId=' + missionId;
    }
    if (surveyCategoryId) {
      url += '&SurveyCategoryId=' + surveyCategoryId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCSurveyReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getQCOnlineUsersReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, roleId, pageNumber, pageSize },
  ) {
    let url = '/Reports/OnlineUsersPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (roleId) {
      url += '&RoleId=' + roleId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCOnlineUsersReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getQCUsersLoginLogoutReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, userId, pageNumber, pageSize },
  ) {
    let url = '/Reports/UsersLoginLogout?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (userId) {
      url += '&UserId=' + userId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCUsersLoginLogoutReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getQCCallsReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, userId, callTagId, source, destination, pageNumber, pageSize },
  ) {
    let url = '/Reports/CallsReport?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (userId) {
      url += '&UserId=' + userId;
    }
    if (callTagId) {
      url += '&CallTagId=' + callTagId;
    }
    if (destination) {
      url += '&Destination=' + destination;
    }
    if (source) {
      url += `&Source=${source}`;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCCallsReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getQCMissionTimesReport(
    { commit, dispatch, rootState },
    {
      fromDate,
      toDate,
      firstUserId,
      secondUserId,
      phoneCode,
      vehicleTypeId,
      cityId,
      dispatchTillMoveMinimum,
      moveTillArriveMinimum,
      patientWaitingDurationMinimum,
      hospitalWaitingDurationMinimum,
      missionDurationMinimum,
      pageNumber,
      pageSize,
    },
  ) {
    let url = '/Reports/MissionTimes?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (firstUserId) {
      url += '&FirstUserId=' + firstUserId;
    }
    if (secondUserId) {
      url += '&SecondUserId=' + secondUserId;
    }
    if (phoneCode) {
      url += '&PhoneCode=' + phoneCode;
    }
    if (vehicleTypeId) {
      url += '&VehicleTypeId=' + vehicleTypeId;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    if (dispatchTillMoveMinimum) {
      url += '&DispatchTillMoveMinimum=' + dispatchTillMoveMinimum;
    }
    if (moveTillArriveMinimum) {
      url += '&MoveTillArriveMinimum=' + moveTillArriveMinimum;
    }
    if (patientWaitingDurationMinimum) {
      url += '&PatientWaitingDurationMinimum=' + patientWaitingDurationMinimum;
    }
    if (hospitalWaitingDurationMinimum) {
      url += '&HospitalWaitingDurationMinimum=' + hospitalWaitingDurationMinimum;
    }
    if (missionDurationMinimum) {
      url += '&MissionDurationMinimum=' + missionDurationMinimum;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCMissionTimesReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getQCMissionFenceTimesReport(
    { commit, dispatch, rootState },
    {
      fromDate,
      toDate,
      firstUserId,
      secondUserId,
      phoneCode,
      vehicleTypeId,
      cityId,
      dispatchTillMoveMinimum,
      moveTillArriveMinimum,
      patientWaitingDurationMinimum,
      hospitalWaitingDurationMinimum,
      missionDurationMinimum,
      pageNumber,
      pageSize,
      MissionIdentifier,
    },
  ) {
    let url = '/Reports/MissionFenceTimes?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (firstUserId) {
      url += '&FirstUserId=' + firstUserId;
    }
    if (secondUserId) {
      url += '&SecondUserId=' + secondUserId;
    }
    if (phoneCode) {
      url += '&PhoneCode=' + phoneCode;
    }
    if (vehicleTypeId) {
      url += '&VehicleTypeId=' + vehicleTypeId;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    if (dispatchTillMoveMinimum) {
      url += '&DispatchTillMoveMinimum=' + dispatchTillMoveMinimum;
    }
    if (moveTillArriveMinimum) {
      url += '&MoveTillArriveMinimum=' + moveTillArriveMinimum;
    }
    if (patientWaitingDurationMinimum) {
      url += '&PatientWaitingDurationMinimum=' + patientWaitingDurationMinimum;
    }
    if (hospitalWaitingDurationMinimum) {
      url += '&HospitalWaitingDurationMinimum=' + hospitalWaitingDurationMinimum;
    }
    if (missionDurationMinimum) {
      url += '&MissionDurationMinimum=' + missionDurationMinimum;
    }
    if (MissionIdentifier) {
      url += '&MissionIdentifier=' + MissionIdentifier;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCMissionFenceTimesReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getQCTechnicianPerformancePaginationReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, userId, cityId, pageNumber, pageSize },
  ) {
    let url =
      '/Reports/TechnicianPerformancePagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (userId) {
      url += '&UserId=' + userId;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCTechnicianPerformancePaginationReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getQCUsersForQCReport(
    { commit, dispatch, rootState },
    { fullName, roleId, nationalCode, pageNumber, pageSize },
  ) {
    let url = '/Reports/UsersForQC?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fullName) {
      url += '&FullName=' + fullName;
    }
    if (roleId) {
      url += '&RoleId=' + roleId;
    }
    if (nationalCode) {
      url += '&NationalCode=' + nationalCode;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_QCUsersForQCReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  //amar
  getMissionPhoneWithResultByZoneForDailyReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, cityId },
  ) {
    let url = '/Reports/MissionPhoneWithResultByZone';
    if (fromDate || toDate || cityId) {
      url += '?';
    }
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_MissionPhoneWithResultByZone', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getPatientCountByDiagnosisForDailyReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, cityId },
  ) {
    let url = '/Reports/PatientCountByDiagnosis';
    if (fromDate || toDate || cityId) {
      url += '?';
    }
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_PatientCountByDiagnosis', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getInboundCallsForDailyReport({ commit, dispatch, rootState }, { fromDate, toDate, cityId }) {
    let url = '/Reports/InboundCalls';
    if (fromDate || toDate || cityId) {
      url += '?';
    }
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_InboundCalls', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getDailyByZoneReport({ commit, dispatch, rootState }, { fromDate, toDate, cityId }) {
    let url = '/Reports/DailyByZone';
    if (fromDate || toDate || cityId) {
      url += '?';
    }
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_DailyByZone', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getDailyByGeographicalTypeReport({ commit, dispatch, rootState }, { fromDate, toDate, cityId }) {
    let url = '/Reports/DailyByGeographicalType';
    if (fromDate || toDate || cityId) {
      url += '?';
    }
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_DailyByGeographicalType', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getDailyByGeographicalTypeWithCodeReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, cityId },
  ) {
    let url = '/Reports/DailyByCode';
    if (fromDate || toDate || cityId) {
      url += '?';
    }
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_DailyByGeographicalTypeWithCode', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getAmarCodeReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, phoneId, cityId, vehicleTypeId, pageNumber, pageSize },
  ) {
    let url = '/Reports/PhoneActivity?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (phoneId) {
      url += '&PhoneId=' + phoneId;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    if (vehicleTypeId) {
      url += '&VehicleTypeId=' + vehicleTypeId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_AmarCodeActivityReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getAmarRefuelReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, phoneId, vehicleId, userId, minimumLiter, cityId, pageNumber, pageSize },
  ) {
    let url = '/Reports/Refuel?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (phoneId) {
      url += '&PhoneId=' + phoneId;
    }
    if (vehicleId) {
      url += '&VehicleId=' + vehicleId;
    }
    if (userId) {
      url += '&UserId=' + userId;
    }
    if (minimumLiter) {
      url += '&MinimumLiter=' + minimumLiter;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_AmarRefuelReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getAmarHeatMapReport(
    { commit, dispatch, rootState },
    { fromDate, toDate, diagnosis, resultId, tagId, cityId },
  ) {
    let url = '/Reports/HeatMap?';
    if (fromDate) {
      url += 'FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (diagnosis) {
      url += '&Diagnosis=' + diagnosis;
    }
    if (resultId) {
      url += '&ResultId=' + resultId;
    }
    if (tagId) {
      url += '&TagId=' + tagId;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_AmarHeatMapReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getReportParameterData({ commit, dispatch, rootState }, id) {
    let url = '/Reports/BaseType?reportBaseTypeEnum=' + id;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_AmarBaseTypeDataReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  setReportParamsForCustomReportAmar({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Reports/CustomReport', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_CustomReportInfo', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  //Limit Report
  getHospitalPcrFormAccidentTrauma({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        'Reports/HospitalPcrFormAccidentTrauma?missionPhoneId=' +
        missionPhoneId +
        '&patientId=' +
        patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormAccidentTrauma', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getHospitalPcrFormOtherTrauma({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        '/Reports/HospitalPcrFormOtherTrauma?missionPhoneId=' + missionPhoneId + '&patientId=' + patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormOtherTrauma', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getHospitalPcrFormBrainStroke({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get(
        '/Reports/HospitalPcrFormBrainStroke?missionPhoneId=' + missionPhoneId + '&patientId=' + patientId,
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then((response) => {
        commit('SET_PcrFormBrainStroke', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getHospitalPcrFormHeart({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get('/Reports/HospitalPcrFormHeart?missionPhoneId=' + missionPhoneId + '&patientId=' + patientId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PcrFormHeart', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getHospitalPcrFormDisease({ commit, dispatch, rootState }, { missionPhoneId, patientId }) {
    return apiClient
      .get('/Reports/HospitalPcrFormDisease?missionPhoneId=' + missionPhoneId + '&patientId=' + patientId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PcrFormDisease', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
  getHospitalPcrFormWithoutPatient({ commit, dispatch, rootState }, missionPhoneId) {
    return apiClient
      .get('/Reports/HospitalPcrFormWithoutPatient?missionPhoneId=' + missionPhoneId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_PcrFormWithoutPatient', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorReport', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
